module.exports = __webpack_public_path__ + "img/placeholder-lands.1b0dbbe6.svg";